import React, { useState } from "react";

export function useForm(initialFValues, validateOnChange = false, validate) {
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
    if (validateOnChange) validate({ [name]: value });
  };

  const handleMultipleInputChange = (newValues, name, newValue) => {
    setValues({
      ...values,
      ...newValues,
      [name]: newValue,
    });

    if (validateOnChange) validate({ [name]: newValue });
  };

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  };

  return {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    handleMultipleInputChange,
    resetForm,
  };
}

export function Form(props) {
  const { classes, children, ...other } = props;
  return (
    <form
      className={
        classes
          ? classes
          : "h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
      }
      {...other}
    >
      {props.children}
    </form>
  );
}
